export default class UpdateWorkTypeGroupError extends Error {

}
